<template>
  <b-button
    variant="warning"
    size="sm"
    @click="moderatePublication(item)"
  >
    <template v-if="itemEnabled(item)">
      <i class="ti ti-close" />
    </template>
    <template v-else>
      <i class="ti ti-check" />
    </template>
  </b-button>
</template>

<script>
  export default {
    name: 'ModerateButtonComponent',
    components: {
    },
    props: {
      item: {
        type: Object,
        default() {
          return {};
        },
      },
      name: {
        type: String,
        default: '',
      },
      uid: {
        type: Number,
        default: null,
      },
    },
    methods: {
      moderatePublication(item) {
        const state = item.enabled ? 'disable' : 'enable';
        this.$ajax.get(`api/memorial/${this.user().memorial.id}/${this.name}/${item.id}/${state}`)
          .then((response) => {
            if (response.status) {
              this.$bus.$emit(`t-event.ajax-index.ajax-table-${this.uid}.refresh`);
              this.itemEnabled(item);
            }
          });
      },
      itemEnabled(item) {
        return !_.isNil(item.enabled) ? item.enabled : true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  /deep/ .mosaic {
    .mosaic-item {
      padding: 10px;
      border: 1px solid $light-grey;
      border-radius: 4px;
      word-break: break-all;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ModerateButton.vue